export default __webpack_public_path__ + "static/media/calendar.b2ad67ab.svg";